const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(unauthenticated)/organizations/invites/error/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { type DefaultErrorProps } from '@/components/common/error/DefaultError';
const searchSchema = z.object({
  message: z.string()
});
export const Route = createFileRoute('/(unauthenticated)/organizations/invites/error/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(searchSchema)
});